import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  forwardRef,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild
} from "@angular/core";
import {AbstractVisbosControl} from "../../../core/visbos-core/ui/forms/abstract-visbos-control";
import {AbstractControl, FormArray, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ShoppingCart} from "../../../shared/view-model/store-management/shopping-cart.type";
import {appInjector} from "../../../index";
import {ActivatedRoute, Router} from "@angular/router";
import {ProcurementService, ShoppingCartResult} from "../../services/procurement-service/procurement.service";
import {ApolloQueryObservable} from "apollo-angular";
import {NgRedux} from "@angular-redux/store";
import {IAppState} from "../../../shared/redux-store/store";
import {ShoppingCartItem} from "../../../shared/view-model/store-management/shopping-cart-item.type";
import {GenericModalComponent} from "../../../core/visbos-core/ui/forms/generic-modal/generic-modal.component";
import {AddressFormComponent} from "../../../core/visbos-core/ui/forms/address-form/address-form.component";

import {vbConfig} from "../../../configuration";
import {SessionActions} from "../../../shared/actions/session.actions";
import {MessageType} from "../../../shared/redux-store/session/session.types";
import {Order} from "../../../shared/view-model/store-management/order.type";
import {Location} from "@angular/common";
import {map} from "rxjs/operators";
import {Observable} from "rxjs/Observable";
import {Subscription} from "rxjs/Subscription";

@Component({
  selector: 'vb-new-order',
  templateUrl: './new-order.component.html',
  styleUrls: ['./new-order.component.css'],
  providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => NewOrderComponent)}]
})
export class NewOrderComponent extends AbstractVisbosControl<ShoppingCart, FormGroup> implements OnInit, OnDestroy {

  @ViewChild('page')
  page: ElementRef;

  @ViewChild('buyButtonTmpl')
  buyButtonTmpl: TemplateRef<any>;

  @ViewChild('addressModal')
  addressModal: GenericModalComponent;

  @ViewChild('addressForm')
  addressForm: AddressFormComponent;

  private cartCuid$: Observable<string>;

  private shoppingCart$: ApolloQueryObservable<ShoppingCartResult>;
  shoppingCart: ShoppingCart;
  private shoppingCartSub: Subscription;

  orderItemsCtrl: AbstractControl[];

  orderResult: Order;

  total: number = 0.0;

  constructor(fb: FormBuilder, cd: ChangeDetectorRef,
              private location: Location,
              private route: ActivatedRoute,
              private router: Router,
              private procurementService: ProcurementService,
              private ngRx: NgRedux<IAppState>,
              sessionActions: SessionActions) {
    super(fb, cd, sessionActions);

  }

  ngOnInit() {
    super.ngOnInit();

    this.actions = [
      {
        label: 'Bestellung abschließen',
        icon: 'fa-money-bill',
        action: () => this.placeOrder.apply(this),
        helpText: "Bestellung abschließen und im System verbuchen",
        //templateRef: this.buyButtonTmpl
      }
    ];

    this.orderItemsCtrl = (this.control.get('order_items') as FormArray).controls;
    this.total = 0.0;

    this.cartCuid$ = this.route.params.pipe(map(params => params.shoppingCartCuid));
    this.shoppingCart$ = this.procurementService.loadShoppingCart(null, null, this.cartCuid$);
    this.shoppingCartSub = this.shoppingCart$.subscribe(res => {
      this.shoppingCart = res.data.shoppingCart;
      this.item = this.shoppingCart;
      this.patchItemValues();
    });

  }


  placeOrder() {
    this.procurementService.placeNewOrder(this.shoppingCart.cuid, this.control.value).toPromise()
      .then((res: any) => {
        this.orderResult = res.data.placeOrder;
        this.sessionActions.pushMessage("Die Bestellung wurde im System gespeichert!", MessageType.SUCCESS, "Bestellvorgang");
        this.router.navigate(['../../../bestellungen', this.orderResult.cuid], {relativeTo: this.route});
      })
      .catch(err => {
        this.sessionActions.pushMessage("Fehler beim Anlegen der Bestellung!", MessageType.ERROR, "Bestellvorgang");
      });
  }

  buildControlContent(): FormGroup {
    return NewOrderComponent.initControl(this.fb);
  }

  public static initControl(fb: FormBuilder = null): FormGroup {
    fb = fb ? fb : appInjector().get(FormBuilder);

    return fb.group({
      cuid: [null],
      recipient_name: [null, Validators.required],
      recipient_street: [null],
      recipient_city: [null],
      recipient_country: [null],

      billing_address_name: [null, Validators.required],
      billing_address_street: [null, Validators.required],
      billing_address_city: [null, Validators.required],
      billing_address_country: [null],

      delivery_address_name: [null],
      delivery_address_street: [null],
      delivery_address_city: [null],
      delivery_address_country: [null],

      customer_number: [null],
      commission_number: [null],
      ordered_via: [null],
      order_data: [null],
      order_date: [null],

      contact_person: [null],
      contact_data: [null],

      order_title: [null],
      order_opening_text: [null],
      order_ending_text: [null],

      supplier_id: [null, Validators.required],
      administration_unit_id: [null, Validators.required],

      order_items: fb.array([], Validators.required),

    });
  }

  addressChangeType = 'billing_address';
  addressChangeTitle = "Rechnungsadresse ändern";

  changeAddress(type) {
    this.addressChangeType = type;

    if (type == 'billing_address') {
      this.addressChangeTitle = "Rechnungsadresse ändern";
    } else if (type == 'delivery_address') {
      this.addressChangeTitle = "Lieferadresse ändern";
    } else if (type == 'recipient') {
      this.addressChangeTitle = "Empfängeradresse ändern";
    }

    this.addressModal.show();

  }

  public setDefaultValues(item?: ShoppingCart): { [controlKey: string]: any } | any {

    if (!item) {
      return undefined;
    }

    let recipientCountry = this.setValue(item, 'supplier.address.city.country.name');
    let senderCountry = this.setValue(item, 'administration_unit.address.city.country.name');
    let billingCountry = this.setValue(item, 'administration_unit.billing_address.city.country.name');

    let contactUser = this.ngRx.getState().session.user;

    let relation = this.setValue(item, 'administration_unit.business_relations', []).find(rel => {
      return rel.relation_target.cuid == item.supplier.cuid;
    });

    this.addOrderItems(item.shopping_cart_items, <FormArray>this.control.get('order_items'));

    // Retrieve supplier address line, or let empty if no address if provided
    let recAddressLine = this.isValueSet(item, 'supplier.address.street') || this.isValueSet(item, 'supplier.address.number') ? this.setValue(item, 'supplier.address.street') + " " + this.setValue(item, 'supplier.address.number') : null;

    // Retrieve supplier city line, or let empty if no address if provided
    let recCityLine = this.isValueSet(item, 'supplier.address.city.zip') || this.isValueSet(item, 'supplier.address.city.town') ? this.setValue(item, 'supplier.address.city.zip') + " " + this.setValue(item, 'supplier.address.city.town') : null;

    let ret = {
      cuid: AbstractVisbosControl.cuid(),

      recipient_name: this.setValue(item, 'supplier.address_name'),
      recipient_street: recAddressLine,
      recipient_city: recCityLine,
      recipient_country: recipientCountry != senderCountry ? recipientCountry : null,

      billing_address_name: this.setValue(item, 'administration_unit.billing_address.address_name'),
      billing_address_street: this.setValue(item, 'administration_unit.billing_address.street') + " " + this.setValue(item, 'administration_unit.billing_address.number'),
      billing_address_city: this.setValue(item, 'administration_unit.billing_address.city.zip') + " " + this.setValue(item, 'administration_unit.billing_address.city.town'),
      billing_address_country: recipientCountry != billingCountry ? billingCountry : null,

      delivery_address_name: this.setValue(item, 'administration_unit.address_name'),
      delivery_address_street: this.setValue(item, 'administration_unit.address.street') + " " + this.setValue(item, 'administration_unit.address.number'),
      delivery_address_city: this.setValue(item, 'administration_unit.address.city.zip') + " " + this.setValue(item, 'administration_unit.address.city.town'),
      delivery_address_country: recipientCountry != senderCountry ? senderCountry : null,

      customer_number: this.setValue(relation, 'relation_type.customer_number'),
      commission_number: null,

      ordered_via: this.setValue(relation, 'relation_type.order_kind_label'),
      order_data: relation && relation.relation_type && relation.relation_type.order_kind_label == 'E-Mail' ? relation.relation_type.order_data.email : null,
      order_date: new Date().toISOString().slice(0, 10),

      contact_person: contactUser ? contactUser.form_of_address + " " + contactUser.pre_name + " " + contactUser.name : null,
      contact_data: contactUser ? contactUser.email : null,

      order_title: vbConfig.procurement.order.default_title + " " + this.setValue(item, 'administration_unit.address_name'),
      order_opening_text: vbConfig.procurement.order.default_opening,
      order_ending_text: vbConfig.procurement.order.default_ending,

      supplier_id: this.setValue(item, 'supplier.cuid'),
      administration_unit_id: this.setValue(item, 'administration_unit.cuid'),
    };

    if (ret.contact_person) {
      ret.order_ending_text = vbConfig.procurement.order.default_ending + "<p>" + ret.contact_person + "</p>"
    }

    return ret;
  };

  addOrderItems(items: ShoppingCartItem[], formArray: FormArray) {
    formArray.controls = [];
    items.forEach(item => {
      this.total += item.total_price;
      formArray.push(this.initOrderItemControl(item))
    })
  }

  initOrderItemControl(values?: ShoppingCartItem): FormGroup {

    let stockIDs = values && values.referenced_stocks ? values.referenced_stocks.map(st => st.cuid) : [];

    return this.fb.group({
      cuid: AbstractVisbosControl.cuid(),
      article_number: [this.setValue(values, 'article_number')],
      article_label: [this.setValue(values, 'article_label'), Validators.required],
      packing_unit: [this.setValue(values, 'packing_unit')],
      packing_content: [this.setValue(values, 'packing_content')],
      amount: [this.setValue(values, 'amount'), Validators.required],
      price: [this.setValue(values, 'price')],
      product_packing_id: [this.setValue(values, 'product_packing.cuid')],
      stock_item_id: [this.setValue(values, 'stock_item.cuid')],
      stock_ids: [stockIDs, Validators.required]
    });
  }

  ngOnDestroy(): void {
    if (this.shoppingCartSub) {
      this.shoppingCartSub.unsubscribe();
    }
  }

  orderPdfLink: string;

  generatePDF() {
    if (!this.orderResult) {
      return;
    }

    this.procurementService.generateOrderPDF(this.orderResult.cuid).toPromise()
      .then(res => {
        this.orderPdfLink = res.data.generateOrderPDF;
        window.open(this.orderPdfLink, '_blank', 'location=yes'); //TODO: Check mobile compatibility!
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/procurement/new-order/new-order.component.ts